import React, { useState, useEffect } from "react";
// import image1 from "../image/image1.jpg";
// import image2 from "../image/image2.png";
// import image3 from "../image/image3.png";
import logo from "../../image/logo2.png";
import Team from "../../image/team-3.jpg";
import { Link } from "react-router-dom";
import { Route } from "react-router-dom";
import {
  Row,
  Col,
  Form,
  Button,
  Container,
  Nav,
  Navbar,
} from "react-bootstrap";
import "./PageHomeAdmin.css";
import "./utilities.css";
import Addadmin from "./AddAdmin";
import LoginForm from "./LoginAdmin";
import ServiceAdmin from "./Services/ServiceAdmin";
const Section = () => {
  const [infoSante, setinfoSante] = useState([]);
  const GetInfoSante = () => {
    ServiceAdmin.getProSante().then((res) => {
      setinfoSante(res.data);
    });
  };

  useEffect(() => {
    GetInfoSante();
  }, []);
  console.log(infoSante);
  return (
    <>
      {/* <!-- Navbar --> */}

      <div className="navbarA">
        <Container>
          <Navbar expand="lg">
            <Navbar.Brand>
              <img src={logo} width="96px" />
            </Navbar.Brand>
            {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
            {/* <Navbar.Collapse id="basic-navbar-nav"> */}
            <Nav className="ml-auto navbar-nav">
              <ul>
                <li className="mt-3">
                  <a
                    href="#"
                    style={{ border: "2px #2ecc71 solid", color: "#2ecc71" }}
                  >
                    Accueil
                  </a>
                </li>
                <li className="mt-3">
                  <Link to="/">Je suis un partient</Link>
                </li>
              </ul>
            </Nav>
            {/* </Navbar.Collapse> */}
          </Navbar>
        </Container>
      </div>

      {/* <!-- Showcase --> */}
      <section className="showcase">
        <Container>
          <Row>
            <Col lg={6} sm={12}>
              <div className="showcase-text">
                <span>DOCLIC</span> est une solution logiciel
                <br />
                spécialement conçue pour
                <span> la gestion des rendez-vous pour </span>
                le professionel de la santé.
              </div>
            </Col>
            <Col lg={6} sm={12}>
              {/* <Route exact path="/pagehomeadmin" component={Addadmin} />
              <Route exact path="/pagehomeadmin/login" component={LoginForm} /> */}
              <Addadmin />
              <LoginForm />
            </Col>
          </Row>
        </Container>
      </section>
      {/* <!-- ======= Team Section ======= --> */}

      <section
        id="team2 more-features"
        className="team2 section-bg sectionitem1"
      >
        <Row className=" justify-content-md-center">
          <Col lg={12} style={{ fontSize: "30px" }} className="subtitle title">
            Les Nouveux Practicians
          </Col>
        </Row>

        <div className="container">
          <div className="mt-3 row  justify-content-md-center">
            {infoSante.map((item) => (
              <div className="col-lg-4 col-md-6 d-flex align-items-stretch">
                <div className="member">
                  <img src={Team} alt="" />
                  <h4>{item.lastName}</h4>
                  <span>{item.speciality.designation}</span>
                  <p>{item.details && JSON.parse(item.details).presentation}</p>
                  <Link className="buttons-holder" to="/profile">
                    <Button
                      className=" ybtn ybtn-accent-color"
                      onClick={() => {
                        sessionStorage.setItem(
                          "healthId",
                          JSON.stringify(item)
                        );
                        sessionStorage.setItem(
                          "dataCabinet",
                          JSON.stringify(item.laboratory ? item.laboratory : {})
                        );
                      }}
                    >
                      PRENDRE RENDEZ-VOUS
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* <!-- End Team Section --> */}
      {/* ::::::::::::::::::::::::: */}
      <section id="more-features">
        <Row className=" justify-content-md-center">
          <Col lg={12} className="title">
            DOCLIC
          </Col>
          <Col lg={12} className="subtitle">
            Bénéficiez d’une solution parfaitement adaptée à votre métier
          </Col>
        </Row>
        <Row className="justify-content-md-center">
          <Col lg={3} sm={12}>
            <div className="mfeature-box">
              <div className="mfeature-icon">
                <i
                  className="fas fa-clipboard-check"
                  style={{ color: " #2ECC71" }}
                ></i>
              </div>
              <div className="mfeature-title">
                Prise de Rendez vous en ligne 24h/24
              </div>
              <div className="mfeature-body">
                Avec la prise de RDV en ligne, vous permettez à vos patients de
                prendre RDV à votre cabinet en quelques clics 24h/24.Vous
                recevez moins d’appels ce qui vous permet de ne plus être
                dérangé pendant vos actes médicaux et de désengorger votre
                secrétariat. Votre téléphone est toujours disponible pour les
                appels important.
              </div>
            </div>
          </Col>
          <Col lg={3} sm={12}>
            <div className="mfeature-box">
              <div className="mfeature-icon">
                <i
                  className="fas fa-calendar-alt"
                  style={{ color: " #2ECC71" }}
                ></i>
              </div>
              <div className="mfeature-title">Agenda et Rappels de RDV</div>
              <div className="mfeature-body">
                Profitez d’un agenda en ligne professionnel adapté aux
                spécificités des professions desanté. Vous pourrez également
                activer les rappels de RDV par email pour éviter les oublis.
              </div>
            </div>
          </Col>
          <Col lg={3} sm={12}>
            <div className="mfeature-box">
              <div className="mfeature-icon">
                <i
                  className="fab fa-internet-explorer"
                  style={{ color: " #2ECC71" }}
                ></i>
              </div>
              <div className="mfeature-title">Création de site internet</div>
              <div className="mfeature-body">
                Bénéficiez d’un site à votre image en version web et mobile sans
                aucune compétence technique sur lequel vos patients pourront
                prendre RDV si vous le souhaitez.
              </div>
            </div>
          </Col>
          <Col lg={3} sm={12}>
            <div className="mfeature-box">
              <div className="mfeature-icon">
                <i className="fas fa-list" style={{ color: " #2ECC71" }}></i>
              </div>
              <div className="mfeature-title">
                Fichier Patients et outils de communication
              </div>
              <div className="mfeature-body">
                Notre logiciel vous permet de recueillir toutes les informations
                dont vous avez besoin sur vos patients. De nombreuses fonctions
                sont intégrées au fichier pour vous faciliter la vie :
                Historique des RDV,statistiques, outils de communication par
                email intégré…
              </div>
            </div>
          </Col>
        </Row>
      </section>
      {/* ::::::::::::::::::::::::: */}
      <section>
        <div style={{ backgroundColor: "white", padding: "46px" }}>
          <Container>
            <Row>
              <Col lg={6} sm={12}>
                <div className="text-other-color1">Besoin d'aide ?</div>
                <div className="text-other-color2">
                  Créer Votre Compte ou Contactez-Nous.
                </div>
              </Col>
              <Col lg={6} sm={12}>
                <div className="buttons-holder">
                  <a
                    href="https://app.doclic.ma/"
                    target="_blank"
                    className="ybtn ybtn-accent-color"
                  >
                    Créer Votre Compte
                  </a>
                  <a id="contactbtn" className="ybtn ybtn-white ybtn-shadow">
                    Nous-Contacter
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* ::::::::::::::::::::::::: */}
      <section id="more-features2">
        <Row style={{ marginTop: "25px" }}>
          <Col lg={12} className="title">
            Pourquoi nous choisir ?
          </Col>
          <Col lg={12} className="subtitle">
            Simplifiez vous la vie avec la prise de rendez vous en ligne
          </Col>
        </Row>
        <Row className="justify-content-md-center">
          <Col lg={2} sm={12}>
            <div className="mfeature-box">
              <div className="mfeature-icon">
                <i
                  className="far fa-calendar-check"
                  style={{ color: "deepskyblue" }}
                ></i>
              </div>
              <div className="mfeature-title">
                Facilitez la prise de rendez-vous 24/24
              </div>
            </div>
          </Col>
          <Col lg={2} sm={12}>
            <div className="mfeature-box">
              <div className="mfeature-icon">
                <i className="far fa-bell" style={{ color: "deepskyblue" }}></i>
              </div>
              <div className="mfeature-title">
                Réduisez de vos RDV non honorés
              </div>
            </div>
          </Col>
          <Col lg={2} sm={12}>
            <div className="mfeature-box">
              <div className="mfeature-icon">
                <i
                  className="fas fa-users"
                  style={{ color: "deepskyblue" }}
                ></i>
              </div>
              <div className="mfeature-title">
                Renouvelez votre patientéle si besoin
              </div>
            </div>
          </Col>
          <Col lg={2} sm={12}>
            <div className="mfeature-box">
              <div className="mfeature-icon">
                <i
                  className="far fa-clock"
                  style={{ color: "deepskyblue" }}
                ></i>
              </div>
              <div className="mfeature-title">
                Gagnez du temps tous les jours
              </div>
            </div>
          </Col>
          <Col lg={2} sm={12}>
            <div className="mfeature-box">
              <div className="mfeature-icon">
                <i
                  className="fas fa-globe-americas"
                  style={{ color: "deepskyblue" }}
                ></i>
              </div>
              <div className="mfeature-title">
                Maitrisez votre présence sur Internet
              </div>
            </div>
          </Col>
        </Row>
      </section>
      {/* ::::::::::::::::::::::::: */}
      <footer id="footer">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6 footer-links">
                <div className="big-title">
                  DOCLIC est une solution logiciel
                  <br />
                  spécialement conçue pour la gestion des rendez-vous pour le
                  professionel de la santé.
                </div>
              </div>

              <div className="col-lg-3 col-md-6 footer-links">
                <h4>contact</h4>
                <ul>
                  <li>
                    <a href="#">
                      <i className="fas fa-phone"></i> +212 808 513 704
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fas fa-envelope"></i> contact@taleve.net
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fas fa-map-marker"></i> 14, rue Dayet Aoua,
                      <br />
                      10220 Agdal-Rabat,
                      <br />
                      Maroc.
                    </a>
                  </li>
                </ul>
              </div>

              <div className="col-lg-3 col-md-6 footer-links">
                <h4>Liens</h4>
                <ul>
                  <li>
                    <a href="#">A Propos</a>
                  </li>
                  <li>
                    <a href="#">Login</a>
                  </li>
                  <li>
                    <a href="#">Creation de compte</a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-md-6 footer-links">
                <h4>Nos Réseauxr</h4>
                <ul>
                  <li>
                    <a href="#">
                      <i className="fab fa-facebook"></i> Facebook
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-youtube"></i> Youtube
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <i className="fab fa-linkedin"></i> Linkedin
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            &copy; Copyright
            <strong>
              <span>
                <a href="http://taleve.net"> Taleve</a>
              </span>
            </strong>
            . All Rights Reserved
          </div>
        </div>
      </footer>

      {/* ::::::::::::::::::::::::: */}
    </>
  );
};

export default Section;
